import postRequest from '../../../../../postRequest';

/**
 * Calls sizes endpoint to get sizes of the product.
 *
 * @param {number} productId - 15974689
 * @param {string} siteCode - JD
 * @returns {Promise} { data: { Data: [{}], Pagination: {} }, status: 200 }
 */
async function postSizes(productId, siteCode) {
  const endpoint = '/integration-pim/v1/products/drop-shipment/sizes';

  const body = {
    productId,
    siteCode,
  };
  return new Promise((resolve, reject) => {
    postRequest(endpoint, body, 'Sizes')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default postSizes;
